/** General */
export const EMPTY_TEXT_FIELD = 100;

/** Policy id */

export const EMPTY_POLICY_ID_LOCAL = 101;
export const INVALID_POLICY_ID_LOCAL = 102;

/** Phone number */

export const EMPTY_PHONE_NUMBER_LOCAL = 110;
export const INVALID_PHONE_NUMBER_LOCAL = 111;

/** Email */

export const EMPTY_EMAIL_LOCAL = 120;
export const INVALID_EMAIL_LOCAL = 121;

/** OTP code */

export const EMPTY_OTP_CODE_LOCAL = 130;
export const INVALID_OTP_CODE_LOCAL = 131;

export const localErrorMessagesMap = {
  [EMPTY_TEXT_FIELD]: {
    id: 'Patient.Auth.Login.MissingMandatoryFieldError.TextField',
    defaultMessage: '** :attribute is required',
  },
  [INVALID_POLICY_ID_LOCAL]: {
    id: 'Authentication.Login.Patient.Error.IncorrectCredentials',
    defaultMessage: '** Your credentials are incorrect. Please check your credentials and try again',
  },
  [INVALID_PHONE_NUMBER_LOCAL]: {
    id: 'Authentication.Login.Patient.Error.IncorrectCredentials',
    defaultMessage: '** Your credentials are incorrect. Please check your credentials and try again',
  },
};
